import {
	Component,
	OnInit,
	Input,
	Output,
	SimpleChanges,
	ElementRef,
	EventEmitter,
	OnChanges,
} from "@angular/core";
import { UtilityScripts } from "app/helpers/utility-scripts";
import { ScreenControllerService } from "app/core/controls/screen-controller.service";
import { ApplicationModel } from "app/core/models/application.model";

@Component({
	selector: "app-definition-content",
	templateUrl: "./definition.directive.html",
	styleUrls: ["./definition.directive.scss"],
})
export class DefinitionContentDirective implements OnInit {
	@Input() definitionData: any;
	@Output() closeEvent: EventEmitter<any> = new EventEmitter<any>(); // emits when close button click

	public textDirection: string;
	public textAlign: string;

	constructor(private elementRef: ElementRef ,protected screenController: ScreenControllerService) {
		this.textDirection = ApplicationModel.instance.flowDirection;
		this.textAlign = ApplicationModel.instance.textDirection;
		console.log("DefinitionContentDirective");
	}
	ngOnInit() {}

	ngOnChanges(simplechanges: SimpleChanges) {}

	public closeBtnClickhandler(event) {
		this.closeEvent.emit({ close: true });
	}
	public applyCustomFont(): boolean{
		return UtilityScripts.isCustomFontNeeded(this.screenController.courseContextModel.currentLanguage);
	}
}
